if (!customElements.get('mix-match-progress')) {
  class MixMatchProgress extends HTMLElement {
    connectedCallback() {
      this.handles = new Set(
        JSON.parse(
          this.querySelector('[data-mix-match-handles]')?.textContent || '[]'
        )
      );
      setTimeout(() => window.refreshMixMatchProgress(), 0);
    }

    render(cart) {
      const eligibleQuantity = cart.items.reduce((total, item) => {
        return total + (this.handles.has(item.handle) ? item.quantity : 0);
      }, 0);
      const subtotal = cart.total_price;
      const threshold = Number(this.dataset.threshold);
      const mixProgress = Math.min(eligibleQuantity / 3, 1) * 100;
      const rewardProgress = Math.min(subtotal / threshold, 1) * 100;
      const mixMessage =
        eligibleQuantity === 0
          ? this.dataset.messageEmpty
          : eligibleQuantity === 1
            ? this.dataset.messageOne
            : eligibleQuantity === 2
              ? this.dataset.messageTwo
              : this.dataset.messageThree;

      let rewardMessage = this.dataset.rewardUnlocked;
      if (subtotal < threshold) {
        const remaining = threshold - subtotal;
        const currency = window.Shopify?.currency?.active || 'AUD';
        const formatted = new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency
        }).format(remaining / 100);
        rewardMessage = this.dataset.rewardTemplate.replace('[amount]', formatted);
      }

      this.querySelector('[data-mix-match-message]').textContent = mixMessage;
      this.querySelector('[data-reward-message]').textContent = rewardMessage;
      this.querySelector('[data-mix-match-bar]').style.width = `${mixProgress}%`;
      this.querySelector('[data-reward-bar]').style.width = `${rewardProgress}%`;
      this.querySelector('[data-mix-match-track]').setAttribute(
        'aria-valuenow',
        Math.min(eligibleQuantity, 3)
      );
      this.querySelector('[data-reward-track]').setAttribute(
        'aria-valuenow',
        Math.min(subtotal, threshold)
      );
    }
  }

  customElements.define('mix-match-progress', MixMatchProgress);
}

let mixMatchProgressTimer;
let mixMatchProgressRequest;

window.refreshMixMatchProgress = function(delay = 0) {
  clearTimeout(mixMatchProgressTimer);
  mixMatchProgressTimer = setTimeout(async () => {
    if (!mixMatchProgressRequest) {
      const root = window.Shopify?.routes?.root || '/';
      mixMatchProgressRequest = fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' }
      })
        .then(response => response.json())
        .finally(() => {
          mixMatchProgressRequest = null;
        });
    }

    const cart = await mixMatchProgressRequest;
    document
      .querySelectorAll('mix-match-progress')
      .forEach(progress => progress.render(cart));
  }, delay);
};

document.addEventListener('click', event => {
  if (
    event.target.closest(
      '.js-btn-size, cart-remove-button, button[name="add"], [name="checkout"]'
    )
  ) {
    window.refreshMixMatchProgress(1200);
  }
});

document.addEventListener('change', event => {
  if (event.target.matches('[name="updates[]"]')) {
    window.refreshMixMatchProgress(900);
  }
});

document.addEventListener('change', event => {
  const select = event.target.closest('[data-cart-conversion-select]');
  if (!select) return;

  const card = select.closest('.cart-conversion__card');
  const selectedOption = select.selectedOptions[0];
  const addButton = card.querySelector('[data-cart-conversion-add]');
  const price = card.querySelector('[data-cart-conversion-price]');
  const originalPrice = card.querySelector(
    '[data-cart-conversion-original-price]'
  );

  addButton.dataset.variantId = selectedOption.value;
  price.textContent = selectedOption.dataset.discountedPrice;
  if (originalPrice) {
    originalPrice.textContent = selectedOption.dataset.price;
  }
});

document.addEventListener('click', async event => {
  const addButton = event.target.closest('[data-cart-conversion-add]');
  if (!addButton) return;

  event.preventDefault();

  const panel = addButton.closest('[data-cart-conversion-panel]');
  const status = panel.querySelector('[data-cart-conversion-status]');
  const cartDrawer = document.querySelector('cart-drawer');
  const defaultLabel = addButton.dataset.defaultLabel;

  addButton.disabled = true;
  addButton.textContent = addButton.dataset.addingLabel;
  status.textContent = '';

  try {
    const sections = cartDrawer
      .getSectionsToRender()
      .map(section => section.section);
    const response = await fetch(
      window.routes?.cart_add_url || '/cart/add.js',
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            {
              id: addButton.dataset.variantId,
              quantity: 1
            }
          ],
          sections,
          sections_url: window.location.pathname
        })
      }
    );
    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message);
    }

    cartDrawer.renderContents(data, true);
    window.refreshMixMatchProgress(200);
  } catch (error) {
    status.textContent = error.message;
    addButton.disabled = false;
    addButton.textContent = defaultLabel;
  }
});
